var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4425 7.25H11.25V3.5C11.25 3.0875 10.9125 2.75 10.5 2.75H7.5C7.0875 2.75 6.75 3.0875 6.75 3.5V7.25H5.5575C4.89 7.25 4.5525 8.06 5.025 8.5325L8.4675 11.975C8.76 12.2675 9.2325 12.2675 9.525 11.975L12.9675 8.5325C13.44 8.06 13.11 7.25 12.4425 7.25ZM3.75 14.75C3.75 15.1625 4.0875 15.5 4.5 15.5H13.5C13.9125 15.5 14.25 15.1625 14.25 14.75C14.25 14.3375 13.9125 14 13.5 14H4.5C4.0875 14 3.75 14.3375 3.75 14.75Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f61fdc74dece2cac6e5274b1aec1ca9a.svg";
export { ForwardRef as ReactComponent };